import ConfigurationTemplateDecisionWatch from "./configuration-template-decision-watch";

/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-17
 */

import ConfigurationTemplateOrGroupWatch from "./configuration-template-or-group-watch";
import IsObligatory from "../enums/is-obligatory";
import IsObligatorySatisfied from "../enums/is-obligatory-satisfied";

class ConfigurationTemplateOrGroup {
    constructor() {
        this.watches                    = [];
        this.template_version_object    = null;
        this.is_obligatory_value        = IsObligatory.NO;
        this.obligatory_satisfied_value = null;
        this.default_watch              = null;
        this.used_watches               = [];
        this.used_watch_timeout         = null;
    }

    buildFromJson(json_object){
        this.id = json_object.id;
        this.name = json_object.name;
        this.is_obligatory_value = json_object.is_obligatory;
        this.buildWatches(json_object.cfg_template_or_group_watches);
    }

    buildWatches(watches_json){
        watches_json.forEach((json_object)=>{
            let watch = new ConfigurationTemplateOrGroupWatch();
            watch.or_group = this;
            watch.buildFromJson(json_object);
            this.addWatch(watch);
        });
    }

    addWatch(watch){
        this.watches.push(watch);
        if(watch.isDefault){
            this.default_watch = watch;
        }
    }

    set template_version(value){
        this.template_version_object = value;
    }

    get template_version(){
        return this.template_version_object;
    }

    get obligatory_satisfied(){
        return this.obligatory_satisfied_value;
    }

    get isObligatory(){
        return this.is_obligatory_value === IsObligatory.YES;
    }


    isWatchUsed(watch){
        if(!watch){
            debugger;
        }
        return this.used_watches.indexOf(watch.id) > -1;
    }

    resetUsedWatches(){
        console.log(`Resetting used_watches for or_group:${this.name}`);
        this.used_watches.length = 0;
        this.used_watch_timeout = null;
    }

    addUsedWatch(watch){
        console.log(`Adding used watch or_group:${this.name}, watch for Node:${watch.node.code}`);
        this.used_watches.push(watch.id);
    }

    evaluateStatus(){
        let result = false;
        for(let i=0; i < this.watches.length; i++){
            let watch = this.watches[i];
            if(watch.isSatisfied){
                result = true;
                break;
            }
        }
        if(this.obligatory_satisfied_value !== result){
            this.obligatory_satisfied_value = result;
            if(this.isObligatory && !result){
                this.chooseOneNode();
            }
        }
    }

    chooseOneNode(){
        console.log(`In choose one node for or_group:${this.name}`);
        if(this.default_watch && !this.isWatchUsed(this.default_watch)){
            this.useWatch(this.default_watch);
            this.default_watch.executeAction();
            return;
        }
        for(let i=0; i < this.watches.length; i++) {
            let watch = this.watches[i];
            if(!this.isWatchUsed(watch)){
                this.useWatch(watch);
                watch.executeAction();
                break;
            }
        }
    }

    undoOtherWatches(triggering_watch){
        console.log(`In undo other watches for or_group:${this.name}`);
        for(let i=0; i < this.watches.length; i++) {
            let watch = this.watches[i];
            if(triggering_watch.id !== watch.id) {
                watch.undoAction();
            }
        }
    }

    useWatch(watch){
        this.addUsedWatch(watch);
        if(this.used_watch_timeout){
            clearTimeout(this.used_watch_timeout);
        }
        this.used_watch_timeout = setTimeout(()=>{
            this.resetUsedWatches();
        },100);
    }
}
export default ConfigurationTemplateOrGroup;